import React from "react";
import {Floppy2Fill} from "react-bootstrap-icons";

const SaveButton = ({disabled, onClick, children, btnClass = 'btn-primary'}) =>
{
    const clickHandler = disabled === false ? onClick : null;

    return (
        <button type='button' onClick={clickHandler} style={{marginLeft: '10px'}} disabled={disabled}
                className={'btn btn-icon ' + btnClass + ' btn-icon-right btn-small'}>{children}
        </button>
    )
}

export { SaveButton } ;

